module.exports = __webpack_public_path__ + "static/dev-portfolio-c396edea8b5a9113b32810256f352226.png";